<div
	#origin="cdkOverlayOrigin"
	class="flex h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-secondary-container p-2 shadow-xl transition-all hover:scale-125"
	(click)="togglePopup()"
	cdkOverlayOrigin
>
	@if (!$isPopupOpened()) {
		<img
			src="/static-assets/cotix/cotix_logo.svg"
			class="h-full w-full"
			[@fadeUp]
		/>
	} @else {
		<uikit-icon
			name="angle-down"
			fill="on-secondary-container"
			[@fadeUp]
			size="xl"
		></uikit-icon>
	}
</div>

<ng-template
	(detach)="closePopup()"
	[cdkConnectedOverlayOffsetX]="0"
	[cdkConnectedOverlayOpen]="$isPopupOpened()"
	[cdkConnectedOverlayOrigin]="origin"
	[cdkConnectedOverlayPositions]="cdkConnectedOverlayPositions"
	cdkConnectedOverlay
	[cdkConnectedOverlayHasBackdrop]="false"
	cdkConnectedOverlayPanelClass="cotix-popup-panel"
	cdkConnectedOverlayHeight="800px"
	cdkConnectedOverlayWidth="500px"
	cdkConnectedOverlayFlexibleDimensions
	cdkConnectedOverlayTransformOriginOn=".cotix-popup-panel-container"
>
	<div
		class="cotix-popup-panel-container w-full overflow-hidden rounded-xl bg-canvas shadow-2xl"
		[@dropUp]
	>
		@if ($cotixState().cotixUrl) {
			<cba-cotix-popup
				(closePopup)="closePopup()"
				[cotixUrl]="$cotixState().cotixUrl"
			></cba-cotix-popup>
		}
		@if ($cotixState().error) {
			<uikit-alert
				titre="Une Erreur est survenue"
				subtitle="Une erreur est survenue pendant l'initialisation de votre Assistant de cotation"
				color="alert"
			/>
		}
		@if ($cotixState().loading) {
			<div class="flex h-full w-full items-center justify-center">
				<cba-loader-spinner-ay class="h-12 w-12"></cba-loader-spinner-ay>
			</div>
		}
	</div>
</ng-template>
